"use strict";
exports.__esModule = true;
exports.ALLOWED_INTEGRATION_PROVIDERS_FOR_CONFIORMATION = exports.ALLOWED_INTEGRATION_PROVIDERS = void 0;
exports.ALLOWED_INTEGRATION_PROVIDERS = ['CHANNEX', 'TOURVISIO', 'ADSHOTEL', 'SEJOUR'];
exports.ALLOWED_INTEGRATION_PROVIDERS_FOR_CONFIORMATION = ['SEJOUR'];
//# sourceMappingURL=allowed-integrations.constants.js.map